import { credentialStatusLabel, type CredentialPresence } from './ingestCredentialForm';

export const MET_NORWAY_USER_AGENT = 'DevCockpit/Farmspace (https://devcockpit.ai)';

export type RequestHeaderPresence = {
  user_agent?: string | null;
  user_agent_persisted?: boolean;
  user_agent_source?: 'persisted' | 'provider_default' | null;
  secret?: boolean;
  requires_api_key?: boolean;
};

function compact(value?: string | null): string {
  return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
}

export function looksLikeMetNorway(input: {
  provider?: string | null;
  apiName?: string | null;
  apiId?: string | null;
  baseUrl?: string | null;
} = {}): boolean {
  const blob = [input.provider, input.apiName, input.apiId, input.baseUrl]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  if (blob.includes('api.met.no') || blob.includes('yr.no')) return true;
  const key = compact(blob);
  return key.includes('metnorway') || key.includes('yrno');
}

export function defaultMetUserAgent(input: {
  provider?: string | null;
  apiName?: string | null;
  apiId?: string | null;
  baseUrl?: string | null;
  persisted?: string | null;
} = {}): string {
  const persisted = String(input.persisted || '').trim();
  if (persisted) return persisted;
  if (looksLikeMetNorway(input)) return MET_NORWAY_USER_AGENT;
  return '';
}

export function userAgentStatusLabel(headers?: RequestHeaderPresence | null): string {
  if (headers?.user_agent_persisted && headers.user_agent) return 'User-Agent stored.';
  if (headers?.user_agent_source === 'provider_default') return 'Default User-Agent (not yet persisted).';
  return 'No User-Agent stored.';
}

export function setupStatusLabel(input: {
  provider?: string | null;
  apiName?: string | null;
  apiId?: string | null;
  baseUrl?: string | null;
  authType?: string | null;
  presence?: CredentialPresence | null;
  requestHeaders?: RequestHeaderPresence | null;
} = {}): string {
  if (looksLikeMetNorway(input)) return userAgentStatusLabel(input.requestHeaders);
  return credentialStatusLabel(input.presence, input.authType);
}

export function buildUserAgentSavePayload(userAgent: string): { user_agent: string } {
  return { user_agent: String(userAgent || '').trim() };
}
